import { render, staticRenderFns } from "./SearchCoatingsProducts.vue?vue&type=template&id=60708e4a&scoped=true&"
import script from "./SearchCoatingsProducts.vue?vue&type=script&lang=js&"
export * from "./SearchCoatingsProducts.vue?vue&type=script&lang=js&"
import style0 from "./SearchCoatingsProducts.vue?vue&type=style&index=0&id=60708e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60708e4a",
  null
  
)

export default component.exports